import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap, finalize } from 'rxjs/operators';
import { SpinnerService, EmitEvent, Events } from '../service/spinner.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class SpinnerRequestResponseInterceptor implements HttpInterceptor {
  minekpibaseUrl?: string = '';
  baseUrl?: string = '';
  constructor(private service: SpinnerService) {
    this.minekpibaseUrl = environment.MINE_KPI_BASE_URL;
    this.baseUrl = environment.BASE_URL;
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const randomTime = this.getRandomIntInclusive(0, 1500);
    const started = Date.now();

    if (this.GetNotSkipUrl(req)) {
      this.service.emit(new EmitEvent(Events.httpRequest));
      return next.handle(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            const elapsed = Date.now() - started;
            this.service.emit(new EmitEvent(Events.httpResponse));
          }
          if (event) {
            if (event instanceof HttpErrorResponse)
              this.service.emit(new EmitEvent(Events.httpResponse));
          }
        },
          (error) => {
            if (error instanceof HttpErrorResponse) {
              this.service.emit(new EmitEvent(Events.httpResponse));
            }
          }),
        catchError((error) => {
          this.service.emit(new EmitEvent(Events.httpResponse));
          return throwError(error.message);
        })
      );
    }
    else {
      return next.handle(req);
    }

  }

  GetNotSkipUrl(req: any): boolean {
    if (req.url.search(this.minekpibaseUrl + "dumper_actual") === -1
      // && req.url.search(this.minekpibaseUrl + "preview") === -1
      && req.url.search(this.minekpibaseUrl + "current_lsf") === -1
      && req.url.search(this.minekpibaseUrl + "crusher_actual") === -1
      && req.url.search(this.baseUrl + "PileTarget/GetPileTarget") === -1
      && (req.url.search(this.baseUrl + "CBACrusherPileLinking/GetCBACrusherPileLinking")) === -1
      && req.url.search(this.baseUrl + "CrusherPlan/GetDailyCrusherPlanAvailabilityV3") === -1
      && req.url.search(this.baseUrl + "ShiftOperationDashboard/GetProductionPlan") === -1
      && req.url.search(this.minekpibaseUrl + "production_actual") === -1
      && req.url.search(this.baseUrl + "ConsumptionStatus/GetConsumptionDetailsForInventoryStatus") === -1
      // && req.url.search(this.minekpibaseUrl + "GetMapEquipmentsByMine") === -1
      && req.url.search(this.minekpibaseUrl + "excavator_actual") === -1
      && req.url.search(this.baseUrl + "ShiftOperationDashboard/GetExcavatorplan") === -1
      && req.url.search(this.baseUrl + "ResourceAllocation/GetResourceAllocation") === -1
      && req.url.search(this.minekpibaseUrl + "geo_fence_iot") === -1
      && req.url.search(this.baseUrl + "Common/GetCurrentShift") === -1
      && req.url.search(this.baseUrl + "OperatorDetails/GetOperatorEquipmentDetails") === -1
      && req.url.search(this.baseUrl + "EquipmentMaintenanceNew/GetEquipmentActiveBreakdownStatusNew") === -1
      && req.url.search(this.minekpibaseUrl + "generic/list") === -1
      && req.url.search(this.baseUrl + "CrusherMaster/GetCrusherMaster") === -1
      && req.url.search(this.baseUrl + "PileTarget/GetPileTargetCrusherAllocation") === -1
      // && req.url.search(this.baseUrl + "ConsumptionStatus/GetConsumptionDetailsAllNew") === -1
      && req.url.search(this.minekpibaseUrl + "crusher_based_trip_data") === -1
      && req.url.search(this.baseUrl + "EquipmentDetails/GetAllEquipmentDetails") === -1
      && req.url.search(this.baseUrl + "ResourceAllocation/GetShiftRollingGanttChartData") === -1
      && req.url.search(this.baseUrl + "CrusherPlanAllocation/GetCrusherPileLinkingMasterData") === -1
      && req.url.indexOf(this.baseUrl + "ManualDispatchPlan/GetFleetMonitoringData?initialCall=false") === -1
    ) {
      return true;
    }
    return false;
  }

  getRandomIntInclusive(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min; // The maximum is inclusive and the minimum is inclusive
  }
}
